import React, { Component } from "react";
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";
import { config } from "../shared/config";
import * as util from '../shared/commons';
export default class AnalyticChartCombo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            loading: true
        }
    }
    componentDidMount = () => {
        this.reloadItems();
    }
    reloadItems = () => {
        var items = [
            { "id": 1, "OptionTitle": "[1]" + "مقایسه نمرات به تفکیک کلاس برای تمام دروس", "OptionValue": "chart_1" },
            { "id": 2, "OptionTitle": "[2]" + "مقایسه نمرات به تفکیک دروس برای تمام کلاس ها", "OptionValue": "chart_2" },
            { "id": 3, "OptionTitle": "[3]" + "مقایسه نمرات دانش آموزان به تفکیک دروس برای تمام کلاس ها", "OptionValue": "chart_3" },
        ];
        var newState = { ...this.state };

        newState["loading"] = false;

        newState["items"] = items;

        this.setState(newState);
    }
    onInputChange = (e) => {
        var val = e;
        if (val) {
            this.props.onChange(val.OptionValue);
        }
        else {
            this.props.onChange("");
        }
    }
    getItemIndex = (items, value) => {
        if (items === null) return -1;
        if (items.length === 0) return -1;
        for (var i = 0; i < items.length; i++) {
            if (items[i].OptionValue === value) return i;
        }
        return -1;
    }

    render() {
        var ind = this.getItemIndex(this.state.items, this.props.value);
        var ci = null;
        if (ind >= 0) ci = this.state.items[ind];
        var visible = true;
        if (this.props.visible === false)
            visible = false;
        var display = "block";
        if (!visible) display = "none";

        return (
            <>
                <div className="field" style={{ display: display }}>
                    <label className="font-bold" style={{ width: "100%" }}>
                        نوع نمودار
                    </label>
                    <Dropdown disabled={this.props.disabled} value={ci} onChange={(e) => this.onInputChange(e.value)} options={this.state.items} optionLabel="OptionTitle"
                        placeholder={"نوع نمودار را انتخاب کنید"} className="w-full" checkmark={true} highlightOnSelect={true} filter showClear style={{ width: "100%" }} loading={this.state.loading} />
                </div>
            </>
        );
    }
}

